module.exports = __webpack_public_path__ + "static/skills-713d5c5da1ad8a42287dc6ab2ab5945b.png";